module.exports = __webpack_public_path__ + "static/media/28DGC10.a5d094be.jpg";